import axios from 'axios'

function wrapRequestError(error, error_type = 'unknown') {
    return {
        is_error: true,
        error_type,
        error
    }
}

let error_handelers = {
    falseAndLog: (error, msg) => {
        console.error(msg, error)
        return wrapRequestError(false, 'bad_status')
    },
    returnAndLog: (error, msg) => {
        console.error(msg, error)
        return wrapRequestError(error.response.data, 'bad_status')
    }
}

export function rethrow(value) {
    if (value.is_error) throw value.error
    return value
}

export class Api {
    constructor(resource, settings) {
        this.resource = resource
        this.settings = settings || {
            errorHandler: error_handelers.returnAndLog
        }
    }
    async query(path, method, options = {}) {
        const url = new URL(`${process.env.REACT_APP_TMBACK_URL}/api/${this.resource}/${path}`);
        try {
            const config = { withCredentials: true }
            let data = undefined;
            if (method == 'get') {
                for (let option of Object.keys(options)) {
                    url.searchParams.set(option, options[option])
                }
            }
            else if (['post', 'put', 'patch', 'delete'].includes(method)) {
                data = options;
            }
            else throw new Error(`Method ${method} is not supported`)
            let params = [url.toString(), data, config].filter(x => x)
            const response = await axios[method](...params);
            return response.data;
        } catch (error) {
            if (error?.response?.status === 401) window.location = `/login`;
            return this.settings.errorHandler(error, `Failed to fetch ${method} ${url}`)
        }
    }
}

export class Crud extends Api {
    async find(id, options = {}) {
        options.id = id;
        let body = await this.query(`find`, 'post', options);
        if (body.is_error) {
            return body
        }
        if (body?.data?.length == undefined || body.data.length < 1) {
            let error = new Error("Not found")
            error.code = 404
            error.type = 'not_found'
            return wrapRequestError(error, "not_found")
        }
        return body.data[0]
    }
    async create(data) {
        let body = await this.query(`create`, 'post', data)
        return body
    }
    async get(options) {
        let { paginator, sorting } = options;
        // Old logic
        options.page = 1;
        // New logic
        options.pagination = {
            page: 1
        }
        options.sort = {
            order: 'asc'
        }
        if (paginator) {
            // Old logic
            options.page = parseInt(paginator.currentPage) ?? 1
            // New logic
            options.pagination.page = parseInt(paginator.currentPage) || 1
            if (paginator.limit) options.pagination.limit = parseInt(paginator.limit) || 10
            delete options.paginator;
        }

        options.orderDesc = true
        if (sorting) {
            options.sort.by = sorting.by;
            options.sort.order = sorting.order == "desc" ? 'desc' : 'asc'
            delete options.sorting;
        }
        let body = await this.query(`get`, 'post', options)
        return body
    }
    async all(options) {
        let { paginator, sorting } = options;
        options.pagination = options.pagination ?? {
            page: 1
        }
        options.sort = {
            order: 'asc'
        }
        if (paginator) {
            options.pagination.page = paginator.currentPage
            delete options.paginator;
        }

        if (sorting) {
            options.sort.by = sorting.by;
            options.sort.order = sorting.order == "desc" ? 'desc' : 'asc'
            delete options.sorting;
        }
        let body = await this.query(`all`, 'post', options)
        return body
    }
    async getLang(currentLang, options) {
        let { paginator, sorting } = options;
        options.page = 1;
        if (paginator) {
            options.page = paginator.currentPage.toString()
            delete options.paginator;
        }

        options.orderDesc = true
        if (sorting) {
            options.sort = sorting.by;
            options.orderDesc = sorting.order == "desc"
            delete options.sorting;
        }
        let body = await this.query(`get/${currentLang}`, 'post', options)
        return body
    }
    async update(id, data) {
        let body = await this.query(`update/${id}`, 'put', data)
        return body
    }
    async status(id, status_id) {
        let body = await this.query(`status/${id}`, 'put', { status_id })
        return body
    }

    async patch(id, data) {
        let body = await this.query(`patch/${id}`, 'patch', data)
        return body
    }
}